<template>
  <div id="detail-additional-timesheet">
    <CRow>
      <CCol :md="{ size: 8, offset: 2 }" class="detail-form">
        <div class="text-center">
          <h4 class="title-header">{{ $t("additional_timeSheet.label") }}</h4>
        </div>
        <div class="text-content">
          <label>{{ $t("label.employee_code") }}</label>
          <div class="show-text">{{ additionalTimeSheet.employee_id }}</div>
        </div>

        <div class="text-content">
          <label>{{ $t("label.full_name") }}</label>
          <div class="show-text">
            {{
              additionalTimeSheet.employee
                ? additionalTimeSheet.employee.name
                : ""
            }}
          </div>
        </div>
        <div class="text-content">
          <label>{{ $t("additional_timeSheet.request_date") }}</label>
          <div class="show-text">{{ additionalTimeSheet.work_date }}</div>
        </div>

        <div class="text-content">
          <label>{{ $t("additional_timeSheet.created_date") }}</label>
          <div class="show-text">
            {{ additionalTimeSheet.created_at | formatDate }}
          </div>
        </div>

        <div class="text-content" v-if="additionalTimeSheet.manager_name">
          <label>{{ $t("additional_timeSheet.manager") }}</label>
          <div class="show-text">{{ additionalTimeSheet.manager_name }}</div>
        </div>

        <div class="text-content">
          <label>{{ $t("additional_timeSheet.admin") }}</label>
          <div class="show-text">{{ additionalTimeSheet.admin_name }}</div>
        </div>

        <div class="text-content">
          <label>{{ $t("additional_timeSheet.check_in_real") }}</label>
          <div class="show-text">{{ additionalTimeSheet.start_time_real }}</div>
        </div>

        <div class="text-content">
          <label>{{ $t("additional_timeSheet.check_out_real") }}</label>
          <div class="show-text">{{ additionalTimeSheet.end_time_real }}</div>
        </div>

        <div class="text-content">
          <label>{{ $t("additional_timeSheet.check_in_request") }}</label>
          <div class="show-text">
            {{ additionalTimeSheet.start_time_request }}
          </div>
        </div>

        <div class="text-content">
          <label>{{ $t("additional_timeSheet.check_out_request") }}</label>
          <div class="show-text">
            {{ additionalTimeSheet.end_time_request }}
          </div>
        </div>

        <div class="text-content">
          <label>{{ $t("additional_timeSheet.reason") }}</label>
          <div class="show-text">{{ additionalTimeSheet.reason }}</div>
        </div>

        <div class="text-content">
          <label>{{ $t("additional_timeSheet.evidence") }}</label>
          <div class="image">
            <img
              v-if="additionalTimeSheet.img_evidence"
              v-img
              class="image-evidence"
              :src="additionalTimeSheet.img_evidence"
              width="100"
              height="100"
            />
          </div>
        </div>
      </CCol>
    </CRow>
    <CRow>
      <CCol md="8" sm="12" class="detail-form approval-ot">
        <div class="text-label">
          <div class="text-center">
            <h4 class="title-header">
              {{ $t("overtime.information_approval_ot") }}
            </h4>
          </div>
        </div>
        <div class="text-label-content">
          <div class="table-responsive table-employee-note">
            <table class="table">
              <thead>
                <tr>
                  <th class="index">#</th>
                  <th class="text-center create-by">
                    {{ $t("overtime.employee_approval") }}
                  </th>
                  <th class="text-center create-at">
                    {{ $t("overtime.employee_approval_status") }}
                  </th>
                  <th class="text-center">
                    {{ $t("overtime.employee_approval_note") }}
                  </th>
                  <th class="text-center">
                    {{ $t("overtime.employee_approval_time") }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in additionalTimeSheet.request_approve"
                  :key="index"
                >
                  <th scope="row index">{{ index + 1 }}</th>
                  <td>{{ item.approved_by }}</td>
                  <td class="text-center create-at">
                    {{ $t(`overtime.employee_approval_${item.status}`) }}
                  </td>
                  <td class="text-center comment">{{ item.comment }}</td>
                  <td class="text-center">{{ formatDate(item.updated_at) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </CCol>
    </CRow>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment";

export default {
  name: "Detail",
  metaInfo() {
    return {
      title: this.$t("page_title.page_additional_timeSheet_detail"),
      titleTemplate: "%s | " + this.$t("page_title.head_title")
    };
  },
  data() {
    return {
      employeeIdApproval1: "",
      employeeIdApproval2: "",
      listEmployeeIdApproval: []
    };
  },

  async created() {
    await this.showAdditionalTimeSheet();
  },

  computed: {
    ...mapGetters({
      additionalTimeSheet: "additional-timesheet/additionalTimeSheet"
    })
  },

  methods: {
    ...mapActions("additional-timesheet", ["detailOverTimeRequest"]),

    async showAdditionalTimeSheet() {
      let additionalTimeSheetId = this.$route.params.id;
      await this.detailOverTimeRequest(additionalTimeSheetId);
    },

    objectNotNull(obj) {
      if (obj) {
        return Object.keys(obj).length !== 0;
      }
    },

    formatDate(value) {
      if (value) {
        return moment(String(value)).format("DD/MM/YYYY HH:mm:ss");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#detail-additional-timesheet {
  padding: 20px 100px;

  .note-ot {
    text-align: left;

    p.note {
      font-weight: 700;
      color: #ff1a1a;
    }

    label {
      font-weight: 600;
    }

    margin: 20px 0px;
  }

  .detail-form.approval-ot {
    margin: 20px auto 0;

    .text-label h4 {
      color: #3c4b64;
      font-weight: 600;
      font-size: 16px;
    }
  }

  .table-employee-note {
    background-color: white;
    margin-top: 20px;

    th {
      font-size: 15px;
    }

    td {
      color: #3c4b64;
    }

    td.comment {
      max-width: 300px;
      word-wrap: break-word;
    }
  }

  .title-header {
    border-bottom: 2px solid #ea8910;
    padding-bottom: 15px;
    text-transform: uppercase;
    font-weight: 600;
    font-size: 16px;
  }

  .detail-form {
    padding: 0 50px;
    margin-bottom: 30px;

    .text-label h4 {
      color: #333;
      font-weight: 600;
      font-size: 20px;
      margin-bottom: 30px;

      .icon-text-label {
        margin-left: 8px;
      }
    }

    .text-content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;

      .image {
        width: 70%;
      }

      label {
        width: 30%;
        color: #333;
        font-size: 13px;
        font-weight: 600;
      }
    }

    .show-text {
      border: 1px solid #fff;
      background-color: #fff;
      border: 1px solid #ccc;
      width: 70%;
      padding: 0 10px;
      height: 25px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .text-area {
      height: 60px;
    }

    .required {
      color: #dc1313;
      font-size: 13px;
    }
  }

  #toggle-btn {
    height: 37px;
  }
}
@media only screen and (max-device-width: 767px) {
  #detail-additional-timesheet {
    padding: 0.3rem;
    .detail-form {
      padding: 0.3rem;
      .text-center {
        margin-bottom: 2rem;
      }
      .text-content {
        label {
          width: 100%;
        }
        display: block;
      }
      .show-text {
        width: 100%;
        border-radius: 3px;
      }
    }
  }
}
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
  #detail-additional-timesheet {
    padding: 20px 0;
    .detail-form {
      padding: 0;
    }
  }
}
</style>
